import React from 'react';
import { Grid, Text, Box, MultiSelect } from '@mantine/core';
import { t } from 'i18next';

interface MetricOption {
  value: string;
  label: string;
}

interface MetricsSelectorProps {
  metrics: MetricOption[];
  selectedMetrics: string[];
  onChange: (selected: string[]) => void;
  label?: string;
  placeholderKey: string;
}

export const MetricsSelector: React.FC<MetricsSelectorProps> = ({
  metrics,
  selectedMetrics,
  onChange,
  label = t('graph.selectMetrics'),
  placeholderKey = 'graph.selectMetrics'
}) => {
  return (
    <Grid align="center">
      <Grid.Col span={4}>
        <Text fw={600}>{label}</Text>
      </Grid.Col>
      <Grid.Col span={8}>
        <Box style={{ flex: 'initial' }}>
          <div style={{ position: 'relative', width: '100%', maxWidth: '250px' }} className="hide-pills">
            <style>
              {`
              .hide-pills .mantine-Pill-root {
                display: none !important;
              }
              `}
            </style>
            <MultiSelect
              data={metrics}
              value={selectedMetrics}
              onChange={onChange}
              placeholder={t(placeholderKey, { count: selectedMetrics.length })}
              searchable
              clearable
              w="100%"
            />
          </div>
        </Box>
      </Grid.Col>
    </Grid>
  );
}; 